import { r as registerInstance, h } from './core-dafe424f.js';
var HelloWorld = /** @class */ (function () {
    function HelloWorld(hostRef) {
        registerInstance(this, hostRef);
        this.text = 'Hello World';
    }
    HelloWorld.prototype.render = function () {
        return (h("div", null, h("h2", null, this.text, " component")));
    };
    Object.defineProperty(HelloWorld, "style", {
        get: function () { return ".fade{-webkit-transition:opacity .15s linear;transition:opacity .15s linear}\@media (prefers-reduced-motion:reduce){.fade{-webkit-transition:none;transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition:height .35s ease;transition:height .35s ease}\@media (prefers-reduced-motion:reduce){.collapsing{-webkit-transition:none;transition:none}}:host{display:block;color:red;font-size:20px;background-color:#000;overflow:hidden}"; },
        enumerable: true,
        configurable: true
    });
    return HelloWorld;
}());
export { HelloWorld as c_hello_world };
